export const CIVILMATERIALACOUNT_LOADING = "CIVILMATERIALACOUNT_LOADING";
export const CIVILMATERIALACOUNT_RESET = "CIVILMATERIALACOUNT_RESET";
export const GET_CIVILMATERIALACOUNT = "GET_CIVILMATERIALACOUNT";
export const GET_CIVILMATERIALACOUNT_SUCCESS = "GET_CIVILMATERIALACOUNT_SUCCESS";
export const GET_CIVILMATERIALACOUNT_FAIL = "GET_CIVILMATERIALACOUNT_FAIL";
export const DELETE_CIVILMATERIALACOUNT = "DELETE_CIVILMATERIALACOUNT"
export const DELETE_CIVILMATERIALACOUNT_SUCCESS = "DELETE_CIVILMATERIALACOUNT_SUCCESS"
export const DELETE_CIVILMATERIALACOUNT_FAIL = "DELETE_CIVILMATERIALACOUNT_FAIL"
export const UPDATE_CIVILMATERIALACOUNT = "UPDATE_CIVILMATERIALACOUNT"
export const UPDATE_CIVILMATERIALACOUNT_SUCCESS = "UPDATE_CIVILMATERIALACOUNT_SUCCESS"
export const UPDATE_CIVILMATERIALACOUNT_FAIL = "UPDATE_CIVILMATERIALACOUNT_FAIL"
export const ADD_NEW_CIVILMATERIALACOUNT = "ADD_NEW_CIVILMATERIALACOUNT"
export const ADD_CIVILMATERIALACOUNT_SUCCESS = "ADD_CIVILMATERIALACOUNT_SUCCESS"
export const ADD_CIVILMATERIALACOUNT_FAIL = "ADD_CIVILMATERIALACOUNT_FAIL"